module.exports = __webpack_public_path__ + "img/uploaded-file-icon.89046c50.svg";